export const map_style = [
	{
			'featureType': 'administrative',
			'elementType': 'all',
			'stylers': [
					{
							'saturation': '-100',
					},
			],
	},
	{
			'featureType': 'administrative',
			'elementType': 'geometry.fill',
			'stylers': [
					{
							'gamma': '1.00',
					},
					{
							'lightness': '0',
					},
			],
	},
	{
			'featureType': 'administrative.province',
			'elementType': 'all',
			'stylers': [
					{
							'visibility': 'off',
					},
			],
	},
	{
			'featureType': 'landscape',
			'elementType': 'all',
			'stylers': [
					{
							'saturation': -100,
					},
					{
							'lightness': '-3',
					},
					{
							'visibility': 'on',
					},
			],
	},
	{
			'featureType': 'poi',
			'elementType': 'all',
			'stylers': [
					{
							'saturation': -100,
					},
					{
							'lightness': '50',
					},
					{
							'visibility': 'simplified',
					},
			],
	},
	{
			'featureType': 'poi',
			'elementType': 'labels',
			'stylers': [
					{
							'visibility': 'off',
					},
			],
	},
	{
			'featureType': 'road',
			'elementType': 'all',
			'stylers': [
					{
							'saturation': '-100',
					},
			],
	},
	{
			'featureType': 'road.highway',
			'elementType': 'all',
			'stylers': [
					{
							'visibility': 'simplified',
					},
			],
	},
	{
			'featureType': 'road.arterial',
			'elementType': 'all',
			'stylers': [
					{
							'lightness': '30',
					},
			],
	},
	{
			'featureType': 'road.local',
			'elementType': 'all',
			'stylers': [
					{
							'lightness': '40',
					},
			],
	},
	{
			'featureType': 'transit',
			'elementType': 'all',
			'stylers': [
					{
							'saturation': -100,
					},
					{
							'visibility': 'simplified',
					},
			],
	},
	{
			'featureType': 'water',
			'elementType': 'geometry',
			'stylers': [
					{
							'hue': '#ffff00',
					},
					{
							'lightness': -25,
					},
					{
							'saturation': -97,
					},
			],
	},
	{
			'featureType': 'water',
			'elementType': 'labels',
			'stylers': [
					{
							'lightness': -25,
					},
					{
							'saturation': -100,
					},
					{
							'visibility': 'off',
					},
			],
	},
];



// WEBPACK FOOTER //
// ./scripts/modules/map-style.js